export const commPageWrapClass = '-mx-2 -my-2 sm:-mx-4 sm:-my-4 md:-mx-6 md:-my-6';

export const commShellClass =
  'flex min-h-[calc(100dvh-4.5rem)] flex-col overflow-hidden rounded-none border-0 bg-gray-50 dark:bg-gray-950 sm:min-h-[calc(100dvh-6rem)] sm:rounded-2xl sm:border sm:border-gray-200/80 sm:shadow-sm dark:sm:border-gray-700/80 md:h-[calc(100vh-7.5rem)] md:min-h-[32rem] md:flex-row';

export const commSidebarClass =
  'shrink-0 border-b border-gray-200/80 bg-white dark:border-gray-800 dark:bg-gray-900 md:flex md:w-[14rem] md:flex-col md:border-b-0 md:border-r';

export const commMobileNavWrapClass =
  'flex gap-1 overflow-x-auto px-2 py-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:hidden';

export const commDesktopNavClass = 'hidden flex-1 space-y-1 py-3 md:block';

export const commNavItemClass = (active: boolean) =>
  [
    'flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm transition md:mx-2',
    active
      ? 'bg-primary/10 font-medium text-primary dark:bg-primary/20 dark:text-primary-300'
      : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800',
  ].join(' ');

export const commMainClass = 'flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-white dark:bg-gray-900';

export const commPanelHeaderClass =
  'flex shrink-0 items-center justify-between border-b border-gray-200/80 px-3 py-3 dark:border-gray-800 sm:px-5 sm:py-4';

export const commPanelBodyClass = 'flex-1 overflow-y-auto overflow-x-hidden p-3 sm:p-5';

export const commToolbarClass =
  'flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end';

export const commInputClass =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-base text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-500 sm:text-sm';

export const commSelectClass = commInputClass;

export const commPrimaryBtnClass =
  'inline-flex w-full items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50 sm:w-auto sm:py-2';

export const commSecondaryBtnClass =
  'inline-flex w-full items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 sm:w-auto sm:py-2';

export const commCardClass =
  'rounded-xl border border-gray-200/80 bg-gray-50/50 p-4 dark:border-gray-800 dark:bg-gray-950/50 sm:p-5';

export const commSectionTitleClass = 'text-sm font-semibold text-gray-900 dark:text-white';

export const commSectionDescClass = 'mt-1 text-xs leading-relaxed text-gray-500 dark:text-gray-400';

export const commMobileCardClass =
  'rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:hidden';

export const commDesktopTableWrapClass = 'hidden overflow-x-auto md:block';

export const commAlertOverlayClass =
  'fixed inset-0 z-[70] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4';

export const commAlertPanelClass =
  'w-full max-h-[85vh] overflow-y-auto rounded-t-2xl border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900 sm:max-w-md sm:rounded-2xl';

export const commStickyFooterClass =
  'sticky bottom-0 -mx-3 mt-6 border-t border-gray-200 bg-white/95 px-3 py-3 backdrop-blur dark:border-gray-800 dark:bg-gray-900/95 sm:-mx-5 sm:px-5 md:static md:mx-0 md:border-0 md:bg-transparent md:p-0 md:backdrop-blur-none';
